type Translate = (key: string, options?: { provider: string }) => string;

/** The social provider behind an Auth0 user id, by its brand name; null for anything else. */
export function authProviderName(auth0Id?: string): string | null {
  if (auth0Id?.startsWith('google-oauth2|')) return 'Google';
  if (auth0Id?.startsWith('windowslive|')) return 'Microsoft';
  if (auth0Id?.startsWith('facebook|')) return 'Facebook';
  if (auth0Id?.startsWith('apple|')) return 'Apple';
  return null;
}

/**
 * How the voter signed in, as Settings shows it. `auth0|` ids are email-and-password
 * accounts, which read as "email" rather than our identity vendor's name. Null when
 * the id is missing or from a connection we don't recognize, so the line is hidden
 * rather than guessed.
 *
 * @param t The `settings` namespace's translator.
 */
export function signedInViaLabel(auth0Id: string | undefined, t: Translate): string | null {
  const provider = authProviderName(auth0Id);
  if (provider) return t('signedInVia', { provider });
  if (auth0Id?.startsWith('auth0|')) return t('signedInViaEmail');
  return null;
}
